
import classNames from 'classnames';
import { Container } from 'reactstrap';
import NavBar2 from './Navbar2';
import React, { useEffect, useState } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import {Login} from "../../Login"
import { getAuth, onAuthStateChanged } from "firebase/auth";
import AdComponent from './AdComponent';
// import { Link, useNavigate } from "react-router-dom";
// import { auth, logInWithEmailAndPassword,logout, signInWithGoogle } from "./firebase";

// var __html = require('../../privacy.html');
// var template = { __html: __html };


class PrivacyCom extends React.Component {

  

  constructor(props) {
    super(props);

    this.state = {
    }

    this.previousWidth = -1;

    
  }



  render() {
    return (

      

      <Container  fluid className={classNames('PrivacyCom', { 'is-open': this.props.isOpen })}>
                {/* <NavBar2 toggle={this.props.toggle} /> */}
        
                {/* <div className="screen-share">
        <span dangerouslySetInnerHTML={template} />
      </div> */}
       <div className="App"  >
       <iframe   width = "100%" height="5024" scrolling="no" src="./privacy.html"></iframe>
       </div>
                
        <AdComponent></AdComponent>
      </Container>

      
    );
  }
}




export default PrivacyCom;
